import React, { useRef, useState, useEffect, useMemo } from "react";
import Header from "../../components/headers/Header";
// import Graph from "react-graph-vis"; // ❌ removed
import "./Home.css";
import lab from "../../assets/Images/lab.png";
import Slider from "../../components/slider/Slider";
import { Link } from "react-router-dom";

import Dropdown from "../../components/dropdown/Dropdown";
import nameLogo from "../../assets/Images/footer-1.svg";
import gsap from "gsap";

export default function Home({onAnimationComplete }) {
    const networkRef = useRef(null);
    const [selectedEdge, setSelectedEdge] = useState(null);
    const [isVisible1, setIsVisible1] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);
    const [activeSolution, setActiveSolution] = useState("S_DISP");
    const orgMissionRef1 = useRef(null);
    const orgImpactRef1 = useRef(null);
    const loadingPageRef = useRef(null);
    const logoNameRef = useRef(null);

    
    const slides = [
        <div className="slide-content" key={1}>
            <div className="Slide_Content_Heading">
                <h2>Patient Centric Approach</h2>
            </div>
            <br />
            <br />
            <div>
                <div>{/* Image to be added */}</div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        With a team of over 125 dedicated life sciences professionals across India and the United States
                        , we are committed to accelerating the delivery of safe, effective, and affordable treatments to
                        patients worldwide. Serving clients across every continent, we streamline clinical and
                        nonclinical workflows, enhance data quality, and support regulatory-compliant operations to
                        reduce both development timelines and overall costs. Our integrated expertise ensures that
                        innovative therapies reach those who need them—faster, more efficiently, and with uncompromising
                        quality.
                    </p>
                </div>
            </div>
        </div>,
        <div className="slide-content" key={2}>
            <div className="Slide_Content_Heading">
                <h2>Promoting Evidence-Based Medicine</h2>
            </div>
            <br />
            <br />
            <div>
                <div>{/* Image to be added */}</div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        Our center promotes the use of evidence-based medicine by
                        integrating the latest research findings and clinical guidelines
                        into healthcare practice. By advocating for evidence-based
                        practices, we ensure that patients receive the most effective
                        treatments tailored to their individual needs.
                    </p>
                </div>
            </div>
        </div>,
        <div className="slide-content" key={3}>
            <div className="Slide_Content_Heading">
                <h2>Strengthening Industry Collaborations</h2>
            </div>
            <br />
            <br />
            <div>
                <div>{/* Image to be added */}</div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        Through strategic partnerships, we enhance our capabilities and expand our service
                        offerings. These alliances allow us to integrate traditional
                        clinical research with advanced computational methods, providing
                        comprehensive solutions that address the complex needs of the
                        pharmaceutical and medical device industries.
                    </p>
                </div>
            </div>
        </div>,
        <div className="slide-content" key={4}>
            <div className="Slide_Content_Heading">
                <h2>Supporting the Pharmaceutical, Biotech and Medical Device Sectors</h2>
            </div>
            <br />
            <br />
            <div>
                <div>{/* Image to be added */}</div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        Our specialized services support the pharmaceutical and medical
                        device sectors in bringing new drugs and medical devices to market
                        safely and effectively. By ensuring that clinical trials are
                        executed with precision and adhere to regulatory requirements, we
                        help our clients navigate the complex landscape of clinical
                        research.
                    </p>
                </div>
            </div>
        </div>,
        <div className="slide-content" key={5}>
            <div className="Slide_Content_Heading">
                <h2>Advancing Clinical Excellence</h2>
            </div>
            <br />
            <br />
            <div>
                <div>
                    {/* <img src={lab} alt="lab_image" /> */}
                </div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        At Eupraxia, we pride ourselves on
                        being at the forefront of clinical research. Since our establishment
                        in 2011, we have been dedicated to providing end-to-end clinical
                        research solutions that include study design, data management, and
                        statistical analysis. Our expertise ensures that clinical trials are
                        conducted efficiently and comply with the highest regulatory
                        standards, facilitating the advancement of medical knowledge and
                        innovations.
                    </p>
                </div>
            </div>
        </div>,
        <div className="slide-content" key={6}>
            <div className="Slide_Content_Heading">
                <h2>Turning Data Into Solutions and Insights</h2>
            </div>
            <br />
            <br />
            <div>
                <div>{/* Image to be added */}</div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        We are capitalizing on the growing availability of vast and complex
                        research data by employing innovative approaches to derive
                        meaningful insights. By integrating electronic health records, we
                        rapidly uncover valuable public health information. Additionally,
                        synthesizing data from diverse sources accelerates therapeutic
                        development and enhances the diagnosis of rare diseases. Our tools
                        and methods empower others to achieve these advancements with
                        greater efficiency and speed.
                    </p>
                </div>
            </div>
        </div>,
        <div className="slide-content" key={7}>
            <div className="Slide_Content_Heading">
                <h2>Empowering Healthcare Professionals</h2>
            </div>
            <br />
            <br />
            <div>
                <div>{/* Image to be added */}</div>
                <div className="Impact_Content">
                    <br />
                    <p>
                        Through education and training programs, we empower healthcare
                        professionals with the skills and knowledge needed to deliver
                        patient-centered care. By emphasizing communication, empathy, and
                        shared decision-making, we equip clinicians to provide personalized
                        care that meets the unique needs of each patient.
                    </p>
                </div>
            </div>
        </div>,
    ];

    const Droplist = [
        { label: "Discovery Phase", value: "S_DISP" },
        { label: "CDISC Standardization & Clinical Data Management", value: "S_CDM" },
        { label: "Biostatistics & Data-Driven Inferences", value: "S_SDI" },
        { label: "CMC & Manufacturing Analytics", value: "S_RACMC" },
        { label: "Market Access & Evidence Generation", value: "S_MA" },
        { label: "Medical Devices & Digital Health", value: "S_MDDH" },
    ];


    const handleSolutionClick = (solution) => setActiveSolution(solution);

    useEffect(() => {
        const observer1 = new IntersectionObserver(
            (entries) => entries.forEach((e) => setIsVisible1(e.isIntersecting)),
            { threshold: 0.1 }
        );
        const observer2 = new IntersectionObserver(
            (entries) => entries.forEach((e) => setIsVisible2(e.isIntersecting)),
            { threshold: 0.1 }
        );
        if (orgMissionRef1.current) observer1.observe(orgMissionRef1.current);
        if (orgImpactRef1.current) observer2.observe(orgImpactRef1.current);
        return () => {
            if (orgMissionRef1.current) observer1.unobserve(orgMissionRef1.current);
            if (orgImpactRef1.current) observer2.unobserve(orgImpactRef1.current);
        };
    }, []);
    

    return (
        <div>
            <Header />
            <div className="home_content">
                <br />
                <div
                    className={`Org_Impact ${isVisible2 ? "visible" : ""}`}
                    ref={orgImpactRef1}
                >
                    <br />
                    <div className="Impact_Carosel">
                        <Slider className="Carosel" slides={slides} />
                    </div>
                </div>
                <div className="statistics">
                    <div className="statistics_Heading">
                        <h2>Glimpses of Expertise & Experience</h2>
                        <hr></hr>
                    </div>
                    <br />
                    <br />
                    <div className="statistics_grid">
                        <div className="statistics_row row1">
                            <h4>150+ Clinical Trials</h4>
                            <br />
                            <p>Include Drug Development, Medical Device Testing, and More</p>
                        </div>
                        <div className="statistics_row row4">
                            <h4>50+ Real World Evidence Projects</h4>
                            <br />
                            <p>
                                Completed Providing Valuable Insights That Go Beyond Traditional
                                Clinical Trials.
                            </p>
                        </div>
                        <div className="statistics_row row3">
                            <h4>1M+ Data Points</h4>
                            <br />
                            <p>From Various Clinical Trials and Real-World Studies</p>
                        </div>
                        <div className="statistics_row row3">
                            <h4>
                                Data Analysis and Reporting
                                <br />
                                30% Faster
                            </h4>
                            <br />
                            <p>Than The Industry Standards Average Turnaround Time.</p>
                        </div>

                        <div className="statistics_row row2">
                            <h4>
                                Boasted Data Accuracy Rate of Over
                                <br />
                                99%
                            </h4>
                            <br />
                            <p>
                                Ensuring The Integrity and Reliability of Clinical Data
                                Throughout The Trial Process.
                            </p>
                        </div>

                        <div className="statistics_row row5">
                            <h4>
                                Compliance Rate with Regulatory
                                <br />
                                Standards 100%{" "}
                            </h4>
                            <br />
                            <p>
                                Ensuring All Clinical Trials Meet The Necessary Guidelines and
                                Requirements.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="Solution">
                    <div className="Solution_Heading">
                        <h2>Solutions</h2>
                    </div>
                    <div className="Solution_Content">
                        <div className="Solution_Btns">
                            <button
                                className={activeSolution === "S_DISP" ? "active" : ""}
                                onClick={() => handleSolutionClick("S_DISP")}
                            >
                                Discovery Phase
                            </button>
                            <button
                                className={activeSolution === "S_CDM" ? "active" : ""}
                                onClick={() => handleSolutionClick("S_CDM")}
                            >
                                CDISC Standardization & Clinical Data Management
                            </button>
                            <button
                                className={activeSolution === "S_SDI" ? "active" : ""}
                                onClick={() => handleSolutionClick("S_SDI")}
                            >
                                Biostatistics & Data-Driven Inferences
                            </button>
                            <button
                                className={activeSolution === "S_RACMC" ? "active" : ""}
                                onClick={() => handleSolutionClick("S_RACMC")}
                            >
                                CMC & Manufacturing Analytics
                            </button>
                            <button
                                className={activeSolution === "S_MA" ? "active" : ""}
                                onClick={() => handleSolutionClick("S_MA")}
                            >
                                Market Access & Evidence Generation
                            </button>

                            <button
                                className={activeSolution === "S_MDDH" ? "active" : ""}
                                onClick={() => handleSolutionClick("S_MDDH")}
                            >
                                Medical Devices & Digital Health
                            </button>
                        </div>
                        <div className="Solution_dropList">
                            <Dropdown
                                options={Droplist}
                                onSelect={handleSolutionClick}
                                defaultLabel={"Discovery Phase"}
                            />
                        </div>

                        <div className="Solution_Context">
                            <div
                                className={`S_DISP ${activeSolution === "S_DISP" ? "active" : ""
                                    }`}
                            >
                                <h4>Turning Scientific Promise into Development Readiness</h4>
                                <p>
                                    Transform early research data into actionable development strategies through scientific analytics, translational insights, nonclinical data insights and analysis and regulatory-focused planning with Eupraxia.
                                </p>
                                <br />
                                {/*<Link*/}
                                {/*    to="/solutions/real-world-evidance"*/}
                                {/*    className="Solution_link"*/}
                                {/*>*/}
                                {/*    Learn More*/}
                                {/*</Link>*/}
                            </div>
                            <div
                                className={`S_CDM ${activeSolution === "S_CDM" ? "active" : ""
                                    }`}
                            >
                                <h4>Struggling with Fragmented Clinical Data and Complex Submission Standards?</h4>
                                <p>
                                    Build a foundation for regulatory success through CDASH, SDTM, ADaM, Define.xml, data management, and submission-ready CDISC-compliant datasets with Eupraxia expertise.
                                </p>
                                <br />
                                {/*<Link className="Solution_link">Learn More</Link>*/}
                            </div>
                            <div
                                className={`S_SDI ${activeSolution === "S_SDI" ? "active" : ""
                                }`}
                            >
                                <h4>Data Alone Doesn't Drive Decisions - Insights Do</h4>
                                <p>
                                    Convert complex clinical and nonclinical data into meaningful evidence through biostatistics, statistical programming, integrated analyses, meta-analysis, real-world evidence, and advanced analytics with Eupraxia expertise.
                                </p>
                                <br />
                                {/*<Link className="Solution_link">Learn More</Link>*/}
                            </div>
                            <div
                                className={`S_RACMC ${activeSolution === "S_RACMC" ? "active" : ""
                                }`}
                            >
                                <h4>Regulatory Agencies Expect More Than Manufacturing Data</h4>
                                <p>
                                    Support product development, process validation, analytical method validation, stability programs, comparability assessments, and lifecycle management through scientifically rigorous CMC analytics and regulatory support with Eupraxia expertise.
                                </p>
                                <br />
                                <Link className="Solution_link" to={"/REGULATORY-AFFAIRS-AND-CMC/CMC-Services"}>Learn More</Link>
                            </div>
                            <div
                                className={`S_MA ${activeSolution === "S_MA" ? "active" : ""
                                }`}
                            >
                                <h4>Regulatory Approval Is Only the Beginning</h4>
                                <p>
                                    Demonstrate clinical, economic, and patient value through HEOR, real-world evidence, payer research, market access strategy, comparative effectiveness analyses, and commercialization support.
                                </p>
                                <br />
                            </div>
                            <div
                                className={`S_MDDH ${activeSolution === "S_MDDH" ? "active" : ""
                                }`}
                            >
                                <h4>Bringing Medical Technologies to Market with Confidence</h4>
                                <p>
                                    Support medical device and IVD manufacturers through regulatory pathways, quality management systems, clinical evaluation, post-market surveillance, technical documentation, and global compliance strategies.
                                </p>
                                <br />
                                <Link className="Solution_link" to={"/MedicalDevice"}>Learn More</Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
